// 관리자 목록 페이지네이션.
// 현재 표시 범위(예: 1-30 / 124) + 이전/다음 버튼을 표준 형태로 보여준다.
// offset 기반 목록 화면들이 동일한 페이지 이동 UI 를 공유한다.

import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@oo/ui";

interface PaginationProps {
  page: number; // 0-base 현재 페이지
  pageSize: number;
  total: number;
  onPrev: () => void;
  onNext: () => void;
}

// 표시 범위 텍스트 + 이전/다음. 양 끝 페이지에서는 해당 버튼을 비활성화한다.
export default function Pagination({ page, pageSize, total, onPrev, onNext }: PaginationProps) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const from = total === 0 ? 0 : page * pageSize + 1;
  const to = Math.min(total, (page + 1) * pageSize);
  return (
    <div className="flex items-center justify-between text-sm text-ink-700">
      <span className="tabular-nums">
        {from}-{to} / {total}
      </span>
      <div className="flex gap-2">
        <Button variant="secondary" size="sm" onClick={onPrev} disabled={page === 0}>
          <ChevronLeft size={16} aria-hidden="true" />
          이전
        </Button>
        <Button
          variant="secondary"
          size="sm"
          onClick={onNext}
          disabled={page + 1 >= totalPages}
        >
          다음
          <ChevronRight size={16} aria-hidden="true" />
        </Button>
      </div>
    </div>
  );
}
